import { api } from "@/domains/shared/services/api";

export type ClinicMigrationEligiblePatient = {
    id: string;
    name: string;
    primaryTherapistId?: string | null;
};

export type ClinicMigrationEligibility = {
    eligible: boolean;
    reason: string | null;
    currentPlanSlug: string;
    soloPrimaryPatientCount: number;
    maxPrimaryAfterMigration: number;
    hasActiveClinicMembership: boolean;
    setupClinicId: string | null;
    wizardStep: string | null;
};

export type ClinicMigrationPatientAttachResult = {
    attachedCount: number;
    skippedIds: string[];
};

export const clinicMigrationApi = {
    getEligibility: async () =>
        api.get<ClinicMigrationEligibility>("/auth/me/clinic-migration/eligibility"),

    listEligiblePatients: async () =>
        api.get<ClinicMigrationEligiblePatient[]>("/auth/me/clinic-migration/patients"),

    saveState: async (payload: { step?: string | null; setupClinicId?: string | null }) =>
        api.put<{ ok: boolean }>("/auth/me/clinic-migration/state", payload),

    attachPatients: async (clinicId: string, patientIds: string[]) =>
        api.post<ClinicMigrationPatientAttachResult>("/auth/me/clinic-migration/patients", {
            clinicId,
            patientIds,
        }),
};

export const clinicMigrationBannerStorageKey = "mivoClinicMigrationBannerDismissed";
